export const SHAPES_PROJECT_ID = 'idaishapes';
export const RESNET_MODEL_PATH = '/models/model/model.json';
export const SEG_MODEL_PATH = '/models/seg_model/model.json';